/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import { faAppStore as fabAppStore } from '@fortawesome/free-brands-svg-icons/faAppStore';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faGooglePlay as fabGooglePlay } from '@fortawesome/free-brands-svg-icons/faGooglePlay';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faBloggerB as fabBloggerB } from '@fortawesome/free-brands-svg-icons/faBloggerB';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSearchPlus as farSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';

// Solid
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCity as fasCity } from '@fortawesome/pro-solid-svg-icons/faCity';
import { faClipboardCheck as fasClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowLeft as fasLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker as fasMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';

const exports = {
  fabAppStore,
  fabFacebook,
  fabGooglePlay,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTumblr,
  fabTwitter,
  fabYoutube,
  fabBloggerB,
  fabXTwitter,
  farAt,
  farCheckCircle,
  farDownload,
  farEnvelope,
  farFileCertificate,
  farHandshake,
  farHeart,
  farPrint,
  farSearch,
  farSearchPlus,
  farStroopwafel,
  farUser,
  fasAngleLeft,
  fasAngleRight,
  fasAt,
  fasBars,
  fasBookReader,
  fasBug,
  fasBuilding,
  fasBullhorn,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasCheck,
  fasCheckCircle,
  fasChevronLeft,
  fasCircle,
  fasCircleNotch,
  fasCity,
  fasClipboardCheck,
  fasClock,
  fasDownload,
  fasEnvelope,
  fasFax,
  fasGlobe,
  fasGraduationCap,
  fasHandshake,
  fasHeart,
  fasHome,
  fasImages,
  fasKey,
  fasLink,
  fasLock,
  fasLongArrowLeft,
  fasMap,
  fasMapMarker,
  fasPhone,
  fasPrint,
  fasSearch,
  fasSearchPlus,
  fasShieldAlt,
  fasSignOutAlt,
  fasStroopwafel,
  fasThList,
  fasTimes,
  fasUser,
  fasWindowClose,
};

export default library.add(...Object.values(exports));

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */